import * as React from 'react';
import { NotificationsType } from 'src/reducers/landingPage';
import NotificationsView from '../layouts/NotificationsView';

export interface NotificationsPageProps {
  onComponentDidMount: () => void;
  onComponentWillMount: () => void;
  notifications: NotificationsType[];
  readNotification: (notification: NotificationsType) => void;
  reload: () => void;
  onRowClick: (notification: NotificationsType) => void;
  readAllNotification: () => void;
  onRowClickFbStatus: (orderid: string, rowData: string, feedbackreview: string) => void;  
}

class NotificationsPage extends React.Component<NotificationsPageProps> {
  render() {
    return (
      <div>
        <NotificationsView
          notifications={this.props.notifications}
          readNotification={this.props.readNotification}
          reload={this.props.reload}
          onRowClick={this.props.onRowClick}
          readAllNotification={this.props.readAllNotification}
          onRowClickFbStatus={this.props.onRowClickFbStatus}
        />
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
  componentWillMount() {
    // const url: string = window.location.href;
    this.props.onComponentWillMount();
  }
}

export default NotificationsPage;



// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationsPage.tsx